export const UsersFields = {
    name: 'name',
    username: 'username',
    emailId: 'emailId',
    image: 'image',
    registeredAt: 'registeredAt',
    deviceType: 'deviceType',
    deviceVersion: 'deviceVersion',
    status: 'status'
};

export const UsersSearchParams = {
    nameSearch: 'nameSearch',
    nameSort: 'nameSort',
    emailSearch: 'emailIdSearch',
    emailSort: 'emailIdSort',
    registeredAtSearch: 'registeredAtSort',
    deviceTypeSearch: 'deviceTypeSearch',
    deviceTypeSort: 'deviceTypeSort',
    fromDateSearch: 'fromDate',
    toDateSearch: 'toDate'
}